import api from '../helpers/api';
import { all, takeEvery, call, put } from 'redux-saga/effects';
import * as userConstants from '../constants/user';
import BackendPaths from '../helpers/BackendPaths';
import OtherApplicationsPaths from '../helpers/OtherApplicationsPaths';

function* fetchMe() {
    try {
        const me = yield call(api, BackendPaths.whoami.getPath());
        yield put({ type: userConstants.FETCH_ME_SUCCESS, payload: me });
    } catch (e) {
        yield put({ type: userConstants.FETCH_ME_FAILURE });
        window.location.href = OtherApplicationsPaths.loginURL.getPath();
    }
}

function* watchFetchMe() {
    yield takeEvery(userConstants.FETCH_ME_REQUEST, fetchMe);
}

function* signOut() {
    try {
        yield call(api, BackendPaths.session.getPath(), 'DELETE');
        yield* fetchMe();
    } catch (e) {
        yield put({ type: userConstants.SIGN_OUT_FAILURE });
    }
}

function* watchSignOut() {
    yield takeEvery(userConstants.SIGN_OUT_REQUEST, signOut);
}

export default function* userSagas() {
    yield all([watchFetchMe(), watchSignOut()]);
}



// WEBPACK FOOTER //
// ./src/sagas/userSagas.js